import { render, staticRenderFns } from "./createJoin3.vue?vue&type=template&id=e9b010c0&scoped=true&"
import script from "./createJoin3.vue?vue&type=script&lang=js&"
export * from "./createJoin3.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e9b010c0",
  null
  
)

export default component.exports